import TrailConditionsAlertDisplayed from '../enums/TrailConditionsAlertDisplayed';
import TrailDetailsPageTerrainCondition from '../enums/TrailDetailsPageTerrainCondition';
import TrailDetailsPageTerrainSubtitle from '../enums/TrailDetailsPageTerrainSubtitle';
import { getAmplitudeInstance } from '../amplitudeHelpers';

type logTrailDetailsConditionsViewedParams = {
  alert_displayed?: TrailConditionsAlertDisplayed;
  has_alert: boolean;
  num_terrain_reviews_shown: number;
  terrain_subtitle_shown?: TrailDetailsPageTerrainSubtitle;
  terrain_type_shown?: TrailDetailsPageTerrainCondition;
  trail_id: number;
};

/**
 * User scrolls to the conditions section of the trail details page. This will be fired when the conditions section goes into view not when the section is 100% visible.
 * @param params - Attributes to log with the amplitude event
 * @param params.alert_displayed - The alert displayed on the trail conditions section of the trail details page
 * @param params.has_alert - TRUE if an alert was displayed on the trail conditions section of the trail details page.
 * @param params.num_terrain_reviews_shown - When related reviews are shown below the reported terrain condition in the trail conditions card on the trail details page. If no UGC is available, precipitation data shown.
 * @param params.terrain_subtitle_shown - Whether the user saw related reviews or UGC below the reported terrain condition.
 * @param params.terrain_type_shown - The type of terrain shown in the trail conditions card.
 * @param params.trail_id - The trail id of the associated trail details page.
 */
const logTrailDetailsConditionsViewed = (
  {
    alert_displayed,
    has_alert,
    num_terrain_reviews_shown,
    terrain_subtitle_shown,
    terrain_type_shown,
    trail_id
  }: logTrailDetailsConditionsViewedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'trail details conditions viewed',
    {
      'alert displayed': alert_displayed,
      'has alert': has_alert,
      'num terrain reviews shown': num_terrain_reviews_shown,
      'terrain subtitle shown': terrain_subtitle_shown,
      'terrain type shown': terrain_type_shown,
      'trail id': trail_id
    },
    callback
  );
};

export default logTrailDetailsConditionsViewed;
